import {sourceSnapshot} from './paperEdit.js';
import {speechHandleRange} from './speechHandles.js';
import {projectInterviews} from './projectWorkspace.js';
import {sectionsForDraft} from './storySections.js';

// Every generated passage is reconstructed from authoritative, saved word timing.
export function storySourcesFromRows(rows,rootId) {
  return projectInterviews(rows,rootId).filter(row=>row.media_ready && Array.isArray(row.data.words) && row.data.words.length)
    .map(row=>sourceSnapshot(row));
}

export function storyRequestSources(sources,editorialTags=[]) {
  return sources.map(s=>({id:s.id,title:s.title || s.filename || 'Interview',
    words:s.words.map(w=>({text:w.text,start:w.start,end:w.end})),
    priorities:editorialTags.filter(tag=>tag.sourceId===s.id &&
      s.words[tag.start]?.id===tag.firstWordId&&s.words[tag.end]?.id===tag.lastWordId &&
      ['must','maybe','avoid'].includes(tag.priority))
      .map(tag=>({start:tag.start,end:tag.end,priority:tag.priority}))}));
}

export function storyDraftDuration(passages,sources) {
  const byId=new Map(sources.map(s=>[s.id,s]));
  return passages.reduce((sum,p)=>{
    const s=byId.get(p.sourceId);
    if(!s?.words[p.start]||!s?.words[p.end])return sum;
    const raw={start:s.words[p.start].start,end:s.words[p.end].end};
    const handles=speechHandleRange(s.words,raw,s.duration);
    return sum+Math.max(0,handles.end-handles.start);
  },0);
}

export function buildPaperFromStory(paper,draft,sources,currentSources,{append=false,id=()=>crypto.randomUUID()}={}) {
  if(!draft?.passages?.length)throw new Error('Generate a story draft first.');
  const byId=new Map(sources.map(s=>[s.id,s]));
  const current=new Map(currentSources.map(s=>[s.id,s]));
  const generatedSources={};const blocks=[];
  for(const passage of draft.passages){
    const source=byId.get(passage.sourceId);
    const latest=current.get(passage.sourceId);
    if(!source || !latest || JSON.stringify(source.words)!==JSON.stringify(latest.words))
      throw new Error('An interview transcript has changed since this draft was generated. Generate a fresh draft before using it.');
    const {start,end}=passage;
    if(!Number.isInteger(start)||!Number.isInteger(end)||start<0||end<start||end>=source.words.length)
      throw new Error('A draft passage is no longer a valid source selection.');
    const words=source.words.slice(start,end+1);
    if(words.some(w=>!Number.isFinite(w.start)||!Number.isFinite(w.end)||!w.text))
      throw new Error('A source passage has missing word data.');
    generatedSources[source.id]=source;
    const originalRange={start:words[0].start,end:words.at(-1).end};
    blocks.push({
      id:id(),sourceId:source.id,
      ...speechHandleRange(source.words,originalRange,source.duration),
      originalRange,automaticHandles:true,
      text:words.map(w=>w.text).join(' '),
      editorialSection:passage.section,
      editorialReason:passage.reason,
      editorialContext:passage.context
    });
  }
  return {...paper,
    sources:{...(paper.sources||{}),...generatedSources},
    blocks:append?[...(paper.blocks||[]),...blocks]:blocks,
    sectionHeadings:[...(append?(paper.sectionHeadings||[]):[]),
      ...sectionsForDraft(draft,blocks,{offset:append?(paper.blocks||[]).length:0,id})],
    ...(draft.targetSeconds?{targetRuntimeSeconds:draft.targetSeconds}:{}),
    aiStoryTitle:draft.title,aiStorySummary:draft.summary
  };
}
